<template>
  <div
    :class="['addon',selected? 'selected' : 'not-selected',{hovering:hovering}, {'ui-hidden':hideGlobalUI}]"
    v-toggle-select
    v-toggle-hover
    @click="addonClick"
    v-on-clickaway="deselect"
  >
    <transition name="fade">
      <drag-handle v-if="hovering" pos="left"/>
    </transition>


    <editable-text
      class="addon-title"
      ref="addonTitle"
      :content="addon.addon_title"
      :editable="isEditable"
      @update="addon.addon_title = $event"
    />
    <div class="dots"></div>
    <editable-text
      class="addon-price"
      ref="addon-price"
      :content="addon.addon_price"
      :editable="isEditable"
      @update="addon.addon_price = $event"
    />
    <transition name="fade">
      <button-cluster
        v-if="hovering"
        :buttons="buttons"
        :item="addon"
        btnSize="md-12"
        highlight="blue"
      />
    </transition>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import EditableTextField from '../EditableTextField'

import ButtonCluster from '../UI/ButtonCluster'
import DragHandle from '../UI/DragHandle'

import VueClickaway from 'vue-clickaway'
import ToggleSelect from '../../toggle-select'
import ToggleHover from '../../toggle-hover'

import { mapGetters, mapState } from 'vuex'

export default {

  name: 'MenuItemAddon',
  mixins : [ VueClickaway.mixin, ToggleSelect, ToggleHover ],  
  props : [
    'addon',
  ],  
  components : {
    draggable,
    'editable-text' : EditableTextField,
    'button-cluster' : ButtonCluster, 
    'drag-handle' : DragHandle,
  },
  methods: {
    addonClick : function( evt ) {

      // If this is a non-dynamic element (e.g. '.dots')
      // select the addon title for editing
      let isDynamic = evt.target.classList.contains('dynamic-content')

      if( !isDynamic ) {
        this.$nextTick()
          .then( () => {
            var p = this.$refs.addonTitle.$el;
            var s = window.getSelection();
            s.collapse(p.firstChild, p.innerHTML.length);
          })
      }

    }, // addonClick
    selectDefaultText() {
      this.$nextTick()
        .then( () => {
          var p = this.$refs.addonTitle.$el;
          var s = window.getSelection();
          // start at the beginning of the text
          this.$refs.addonTitle.$el.focus()
          // expand to include the whole text
          s.extend(p.firstChild, p.innerText.length);
        })
    }, // selectDefaultText    

  },
  computed : {
    ...mapState(['hideGlobalUI']),
    ...mapGetters(['isAuthenticated'])
  },
  data () {
    return {
      buttons : [
        {
          title : 'Delete Addon',
          icon : 'delete',
          iconOnly : true,
          class: 'delete-addon-btn',
          clickHandler : (addon, e) => {
            e.preventDefault();
            e.stopPropagation();
            this.$emit('removeAddon', addon.addon_uuid);
          },
          mouseupAction : ()=>{},
          mousedownAction : ()=>{},
        },

      ]
    }
  }, // data
  created() {
    if( this.addon.new ) {
      this.selectDefaultText()
    }

  }, // created
}
</script>

<style lang="scss">
@mixin hoverElem {
  cursor:pointer;
  z-index:1000;
  $borderWidth : 0px;
  &:before {
    content : '';
    position:absolute;
    z-index:-1;
    height:calc(100% + #{$borderWidth*2});
    width:calc(100% + 20px);
    right:0px;
    top:-$borderWidth;
    bottom:-$borderWidth;
    // border-top:$borderWidth solid darken(white, 7%);
    // border-bottom:$borderWidth solid darken(white, 7%);
  }
  &:not(.selected):before{ 
    background-color:darken(white, 8%);
  }
}

$inverseColor : white;
@mixin selectedElem {
  @include hoverElem;
  // background:rgba(138, 251, 109, 0.2);  
  // color:$inverseColor;
  &:before {
    // background-color:blue;
    border-top-color:transparent;
    border-bottom-color:transparent;
  }
  .dots {
    border-bottom:solid 2px rgba(138, 251, 109, 0.6);
  }
}


.addon {
  flex:1 0 50%;
  max-width:100%;
  display:flex;
  font-size:.9rem;
  position:relative;
  > * {
    flex: 0 0 auto;
  }
  .addon-title {
    font-weight:bold;
    &.empty-text {
      width:40px;
      &:focus, &:active {
        border-bottom:2px solid #40C2FF;
      }
      &:not(.selected, .ui-hidden):hover {
        background-color:rgba(#40C2FF, .3);
      }

    }
  }

  .addon-price {
    text-align:right;
    margin-right:10px;
  }
  // &:nth-child(odd) .addon-price {
  //   margin-right:10px;
  // }
  > .dots{
    flex:1 1 auto;
    border-bottom:2px dotted #000;
    // display:inline-block;
  }
  &:not(.ui-hidden) > .dots {
    cursor:move;
  }
  &:hover:not(.ui-hidden) {
    @include hoverElem;
    &:before{ 
      background-color:white;
    }

    > .button-cluster {
      position:absolute;
      right:0px;
      top:0px;
      transform:translateX(100%);
      padding:0;
      display:flex;
      button {
        height:16px;
        padding:2px 6px;
      }
    }
  }
  &.selected {
    @include selectedElem;
  }
}  
</style>


// WEBPACK FOOTER //
// src/components/Menus/MenuItemAddon.vue